/**
 * Localization messages for RolesDashboard component
 */
import sharedMessages from '../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../utils/localization';

const componentMessages = {
  // Page header
  'Role Recommendations': 'roleRecs.dashboard.title',
  'Suggested Roles from Intelligent Recommendations':
    'roleRecs.dashboard.subtitle',

  // Search and filters
  '{count, plural, one {# New Role Recommendation Found} other {# New Role Recommendations Found}}':
    'roleRecs.dashboard.newRecommendations',

  // Zero states
  'Try running the Role Recommendations job to generate Roles':
    'roleRecs.dashboard.zeroState.runJobHint',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export default invertedMessages;
